export default "__VITE_ASSET__rob1L5Mx__"